module.exports = __webpack_public_path__ + "static/media/plntify-index.a2a20e5c.png";